import moment from 'moment'

export const RULE_PURPOSE = {
  TOTAL_REF: 'TOTAL_REF',
  DURATION: 'DURATION',
  SALES_FORECAST: 'SALES_FORECAST',
}

export const RULE_ACTION = {
  OK: 'OK',
  WARN: 'WARN',
  BLOCK: 'BLOCK',
}

const COMPARATORS = {
  LESS_THAN: (actual, threshold) => actual < threshold,
  LESS_THAN_EQUAL: (actual, threshold) => actual <= threshold,
  EQUAL: (actual, threshold) => actual === threshold,
  NOT_EQUAL: (actual, threshold) => actual !== threshold,
  GREATER_THAN_EQUAL: (actual, threshold) => actual >= threshold,
  GREATER_THAN: (actual, threshold) => actual > threshold,
}

// Rule values can carry units or expressions (e.g. "31 days", "2 x $baseline"),
// so we only rely on the leading numeric part for the comparison.
const parseRuleThreshold = (value) => {
  const match = String(value).match(/-?\d+(?:\.\d+)?/)
  return match ? parseFloat(match[0]) : NaN
}

// Returns the rule that applies to `actualValue` for the given purpose, or null
// when none matches. When multiple rules match, the most restrictive one (the
// lowest threshold) takes precedence.
export const evaluateRule = (rules, purpose, actualValue) => {
  if (!Array.isArray(rules) || actualValue == null || Number.isNaN(actualValue)) {
    return null
  }

  const matching = rules
    .filter((rule) => rule.purpose === purpose)
    .map((rule) => ({ ...rule, threshold: parseRuleThreshold(rule.value) }))
    .filter((rule) => {
      const comparator = COMPARATORS[rule.comparison]
      return comparator && !Number.isNaN(rule.threshold) && comparator(actualValue, rule.threshold)
    })

  if (matching.length === 0) {
    return null
  }

  matching.sort((a, b) => a.threshold - b.threshold)

  return matching[0]
}

export const getPromoDurationInDays = (installationFrom, installationTo) => {
  if (!installationFrom || !installationTo) {
    return null
  }

  const from = moment(installationFrom)
  const to = moment(installationTo)

  if (!from.isValid() || !to.isValid()) {
    return null
  }

  return to.diff(from, 'days')
}
